export const urlFromResource = (resource: string) => {
  return `/${resource.replace('/instances', '')}`;
};

export const emailLink = (subject: string, message: string) => {
  return [
    'mailto:confidence@spotify.com?',
    `subject=Support request: ${subject}`,
    `&body=Page: ${encodeURIComponent(
      global.window.location.href,
    )}%0D%0A${message}%0D%0AAdditional details:`,
  ].join('');
};
